import { useQuery } from '@tanstack/react-query';
import { searchCustomers } from 'utils/CustomersAPIUtils';
const DEFAULT_CUSTOMER_TYPES = ['carriers', 'shippers'];
async function fetchCustomers({ queryKey }) {
    const [, { search, customerTypes = DEFAULT_CUSTOMER_TYPES }] = queryKey;
    const res = await searchCustomers({
        queryText: search,
        customerTypes,
    });
    return res.map((item) => ({
        value: item._id,
        label: item.name || item.company_name,
    }));
}
export function useCustomers({ search = '', customerTypes = DEFAULT_CUSTOMER_TYPES, }) {
    const query = useQuery({
        enabled: search.length > 3,
        queryKey: ['fetchCustomers', { search, customerTypes }],
        queryFn: fetchCustomers,
    });
    const { data, error, isLoading, isError, isFetching, isSuccess, status, refetch, } = query;
    return {
        data,
        error,
        isLoading,
        isError,
        isFetching,
        isSuccess,
        status,
        refetch,
    };
}
